


































































































































































































































import { AxiosError } from 'axios';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

import { setErrorFromAxiosError } from '@/utils/helpers';
import { ISystemError, ErrorManager } from '@/models/error';

import {
  IWorkflowFormTemplateRevision,
  WorkflowFormTemplateStateEnum
} from '@/models';

import mixins from '@/utils/mixins';
import Functions from '@/mixins/functions';
import snackbar from '@/mixins/snackbar';
import auth from '@/mixins/auth';

import ALPage from '@/components/core/Page/ALPage.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import FormBuilderStatusDisplay from '@/components/form-builder/FormBuilderStatusDisplay.vue';
import WorkflowFormTemplateWizardFormDialog from '@/components/workflow-form-builder/WorkflowFormTemplateWizardFormDialog.vue';
import WorkflowFormBuilderMetaLabelColumnsDialog from '@/components/workflow-form-builder/WorkflowFormBuilderMetaLabelColumnsDialog.vue';

const baseMixins = mixins(Functions, auth, snackbar);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    workflowFormTemplateDialog: InstanceType<
      typeof WorkflowFormTemplateWizardFormDialog
    >;
    workflowFormBuilderMetaLabelColumnsDialog: InstanceType<
      typeof WorkflowFormBuilderMetaLabelColumnsDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    components: {
      ALPage,
      ConfirmationDialog,
      ErrorAlert,
      DetailOptionsButton,
      WorkflowFormBuilderMetaLabelColumnsDialog,
      WorkflowFormTemplateWizardFormDialog,
      FormBuilderStatusDisplay
    },

    data() {
      return {
        loading: false,
        isSearchFilterActive: false,

        error: null as ISystemError | null,

        deleteErrorMessage: '',

        search: '',

        sortBy: 'id',
        sortDesc: true,

        headers: [
          {
            text: '#',
            sortable: false,
            value: 'index'
          },

          {
            text: 'Title',
            sortable: false,
            value: 'template.title'
          },
          {
            text: 'Owner',
            sortable: false,
            value: 'owner'
          },

          {
            text: 'Series',
            sortable: false,
            value: 'template.series_origin'
          },

          {
            text: 'Last Modified',
            sortable: false,
            value: 'updated_at'
          },
          {
            text: 'Status',
            sortable: false,
            align: 'center',
            value: 'state'
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            value: 'actions'
          }
        ],

        selectedFormTemplate: {} as IWorkflowFormTemplateRevision,
        deleteDialog: false,

        createNewRevisionDialog: false,
        createNewRevisionError: null as ISystemError | null,
        createNewRevisionInProgress: false,

        WorkflowFormTemplateStateEnum: WorkflowFormTemplateStateEnum
      };
    },

    computed: {
      ...mapGetters({
        workflowFormTemplates:
          'workflowFormTemplate/getWorkflowFormTemplateRevisions',
        getWorkflowFormTemplateRevisionById:
          'workflowFormTemplate/getWorkflowFormTemplateRevisionById',
        getLastCreatedWorkflowFormTemplateRevisionId:
          'workflowFormTemplate/getLastCreatedWorkflowFormTemplateRevisionId'
      })
    },

    mounted() {
      this.loading = true;

      try {
        this.fetchWorkflowFormTemplates();
        this.fetchWorkflowFormTemplatesRevisions();
      } catch (error) {
        this.error = setErrorFromAxiosError(error as AxiosError);
      } finally {
        this.loading = false;
      }
    },

    methods: {
      moment,

      ...mapActions({
        fetchWorkflowFormTemplates:
          'workflowFormTemplate/fetchWorkflowFormTemplates',
        fetchWorkflowFormTemplatesRevisions:
          'workflowFormTemplate/fetchWorkflowFormTemplatesRevisions',
        deleteWorkflowFormTemplateRevision:
          'workflowFormTemplate/deleteWorkflowFormTemplateRevision',

        createNewWorkflowTemplateRevision:
          'workflowFormTemplate/createNewWorkflowTemplateRevision'
      }),

      goToDetailPage(revision: IWorkflowFormTemplateRevision) {
        this.$router.push({
          name: 'workflow-form-template-detail',
          params: {
            templateId: String(revision.template!.id),
            revisionId: String(revision.id)
          }
        });
      },

      openWorkflowFormDialog(revision?: IWorkflowFormTemplateRevision) {
        this.$refs.workflowFormTemplateDialog.open(revision);
      },

      openWorkflowMetaLabelColumnsFormDialog(
        revision: IWorkflowFormTemplateRevision
      ) {
        this.$refs.workflowFormBuilderMetaLabelColumnsDialog.open(revision);
      },

      openWorkflowFormTemplateDeleteDialog(
        template: IWorkflowFormTemplateRevision
      ) {
        this.selectedFormTemplate = template;
        this.deleteDialog = true;
      },

      clearAllErrors(): void {
        this.error = null;
      },

      closeDeleteDialog() {
        this.deleteDialog = false;
      },

      closeCreateNewRevisionDialog() {
        this.createNewRevisionDialog = false;
        this.createNewRevisionError = null;
      },

      createNewRevision(oldRevision: IWorkflowFormTemplateRevision) {
        this.clearAllErrors();
        this.createNewRevisionInProgress = true;

        this.createNewWorkflowTemplateRevision({
          templateId: oldRevision.template!.id,
          revisionId: oldRevision.id
        })
          .then(() => {
            const newRevision = this.getWorkflowFormTemplateRevisionById(
              this.getLastCreatedWorkflowFormTemplateRevisionId
            );

            this.closeCreateNewRevisionDialog();

            this.createSnack({
              color: 'success',
              type: 'success',
              right: true,
              useBtn: false,
              msg: 'Currently viewing latest revision',
              btnText: 'Close',
              timeout: 6000
            }).then(() => {
              this.openWorkflowFormDialog(newRevision);
            });
          })
          .catch(error => {
            this.createNewRevisionError = setErrorFromAxiosError(
              error as AxiosError
            );
          })
          .finally(() => {
            this.createNewRevisionInProgress = false;
          });
      },

      removeWorkflowFormTemplate(
        selectedFormTemplate: IWorkflowFormTemplateRevision
      ) {
        this.loading = true;

        this.deleteWorkflowFormTemplateRevision({
          templateId: selectedFormTemplate.template!.id,
          revisionId: selectedFormTemplate.id
        })
          .then(() => {
            this.closeDeleteDialog();
          })
          .catch(error => {
            this.deleteErrorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  });
